import React from "react";
import { TICKER, STATS } from "@/lib/site";
import { useProof } from "@/lib/proof";
import { Container, CountUp, Reveal } from "@/components/ui-kit";

export const LogoMarquee = () => {
  const { items, mode } = useProof("logos");
  if (mode === "hidden" || !items.length) return null;
  return (
    <div className="border-y border-mk-border bg-mk-surface/50" data-testid="logo-marquee">
      <Container className="py-6">
        <div className="text-center text-xs text-mk-muted uppercase tracking-[0.2em] font-mono mb-5">Trusted by facilities teams running thousands of properties</div>
        <div className="overflow-hidden mask-fade-x">
          <div className="flex w-max gap-14 marquee items-center">
            {[...items, ...items].map((l, i) => (
              l.logo_url
                ? <img key={i} src={l.logo_url} alt={l.name} loading="lazy" className="h-8 sm:h-9 w-auto max-w-[160px] object-contain opacity-70 hover:opacity-100 transition-opacity" />
                : <span key={i} className="font-display text-lg sm:text-xl font-semibold text-mk-dim/70 whitespace-nowrap hover:text-mk-text transition-colors">{l.name}</span>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export const OpsTicker = () => (
  <div className="border-b border-mk-border bg-mk-bg overflow-hidden" data-testid="ops-ticker">
    <div className="flex w-max gap-10 marquee-fast py-2.5 font-mono text-[11px] text-mk-dim">
      {[...TICKER, ...TICKER].map((t, i) => (
        <span key={i} className="inline-flex items-center gap-2 whitespace-nowrap"><span className="live-dot" />{t}</span>
      ))}
    </div>
  </div>
);

export const StatsBand = () => (
  <Container className="py-16 lg:py-20" data-testid="stats-band">
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-px rounded-2xl border border-mk-border bg-mk-border overflow-hidden">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={i * 0.08} className="bg-mk-surface p-7 lg:p-9">
          <div className="font-display text-4xl lg:text-5xl font-bold text-mk-text tracking-tight">
            <CountUp value={s.value} prefix={s.prefix} suffix={s.suffix} decimals={s.decimals} display={s.display} className="text-mk-lime" />
          </div>
          <div className="mt-2 text-sm text-mk-dim leading-snug">{s.label}</div>
        </Reveal>
      ))}
    </div>
  </Container>
);
